import { Divider, DividerProps } from 'tdesign-react';

import styles from './index.module.less';

export const NovaDivider: React.FC<DividerProps> = props => <Divider {...props} className={styles.dividerWrapper} />;
